import JSONPretty from 'react-json-pretty';
import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Loading } from 'tdesign-react';
import acaiTheme from 'react-json-pretty/dist/acai';
import { connect } from 'react-redux';
import { useMemoizedFn } from 'ahooks';
import Descriptions from '@/components/Descriptions';
import { isValidJSON, isVoid } from '@/utils/common';
import { fetchMessageById } from '@/slices/messageTrace';

function MessageDeatil({ message, loading, row, fetchMessageById }) {
  const messageBody = useMemo(() => {
    const { data } = message;
    if (isVoid(data)) {
      return '暂无数据';
    }
    if (isValidJSON(data)) {
      return JSON.parse(data);
    }

    return data;
  }, [message]);

  const properties = useMemo(() => {
    const { properties } = message;
    if (isVoid(properties)) {
      return '暂无数据';
    }
    if (isValidJSON(properties)) {
      return JSON.parse(properties);
    }

    return properties;
  }, [message]);

  const loadMessageDetail = useMemoizedFn(() => {
    fetchMessageById({
      topic: row.topic,
      messageId: row.fullMessageName,
      clusterName: row.clusterName,
    });
  });

  useEffect(() => {
    loadMessageDetail();
  }, [loadMessageDetail]);

  return (
    <>
      <Loading loading={loading}>
        <Root>
          <Descriptions title='基础信息' column={3} emptySuffix='-'>
            <Descriptions.Item label='消息ID' value={message.messageId} />
            <Descriptions.Item label='生产者' value={message.producerName} />
            <Descriptions.Item
              label='消息创建时间'
              value={message.clientPublishTime}
              type='dateMillionTime'
            />
          </Descriptions>
          <Descriptions title='消息体'>
            <JSONPretty
              className='json-wrap narrow-scrollbar'
              data={messageBody}
              theme={acaiTheme}
            />
          </Descriptions>
          <Descriptions title='详情参数'>
            <JSONPretty
              className='json-wrap narrow-scrollbar'
              data={properties}
              theme={acaiTheme}
            />
          </Descriptions>
        </Root>
      </Loading>
    </>
  );
}

export default connect(
  (state) => ({
    message: state.messageTrace.message,
    loading: state.messageTrace.loading,
  }),
  {
    fetchMessageById,
  },
)(MessageDeatil);

const Root = styled.div`
  .descriptions {
    margin-top: 16px;
  }
  .json-wrap {
    overflow: auto;
    max-height: 350px;
    box-sizing: border-box;
    border-radius: 5px;
    flex: 1;
    background-color: #1e1e1e;

    scrollbar-color: #fff transparent;

    pre {
      margin: 0;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 5px;
    }
  }
`;
